import axios from "../axiosSetup";

export const getPriceList = async ({ search = "", productType = "", page = 1, pageSize, sortField = "", sortOrder = "" } = {}) => {
  const sortParamMap = {
    productCode: "orderByProductCode",
    productName: "orderByProductName",
    customerPrice: "orderByCustomerPrice",
  };

  const params = {
    page,
    limit: pageSize || undefined,
    productType: productType || undefined,
    productCode: search || undefined,
  };

  const sortParam = sortParamMap[sortField];
  if (sortParam && sortOrder) {
    params[sortParam] = sortOrder;
  }

  const res = await axios.get("/customer/price-listing", { params });
  return {
    items: res.data.priceListing ?? [],
    totalPages: Math.max(1, res.data.totalPages || 0),
    currency: res.data.currency || "",
    // Not provided by this endpoint yet — kept so PriceList.jsx can prefer it
    // the moment the backend starts sending it, falling back otherwise.
    total: res.data.total ?? res.data.totalCount ?? res.data.totalItems ?? null,
  };
};

export const getProductTypes = async () => {
  const res = await axios.get("/dropdown/product-type");
  return Array.isArray(res.data) ? res.data : [];
};
